import { Controller } from "@hotwired/stimulus";

/**
 * Dispatches a named CustomEvent on `window` when the element is clicked.
 *
 * Usage:
 *   <a data-controller="util--global-event"
 *      data-util--global-event-name-value="ai-chat:open"
 *      data-action="click->util--global-event#fire"
 *      href="#">Open Chat</a>
 */
export default class extends Controller {
  static identifier: string;
  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }

  static values = { name: String };
  declare nameValue: string;

  fire(event: Event) {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent(this.nameValue));
  }
}
